import * as React from 'react';
import { Button, Col, ControlLabel, FormControl, FormGroup, Modal } from 'react-bootstrap';
import MaskedInput from 'react-maskedinput';
import { ICenterAddress } from '@nkr/models/index';
import { FormWrapper } from './styles';

interface IProps {
    show: boolean,
    campaignName: string,
    addressList: ICenterAddress[],
    onOrder: (orderCount: number, addressId: number) => void,
    onCancel: () => void
}

const OrderBrochures: React.FunctionComponent<IProps> = (props) => {
    const [orderCount, setOrderCount] = React.useState('');
    const [addressId, setAddress] = React.useState(0)

    const handleOrderCountChange = (e: React.ChangeEvent<FormControl & HTMLInputElement>) => {
        setOrderCount(e.currentTarget.value);
    }

    const handleShippingAddressChange = (e: React.ChangeEvent<FormControl & HTMLSelectElement>) => {
        setAddress(parseInt(e.currentTarget.value));
    }

    const handleSubmit = () => {
        props.onOrder(parseInt(orderCount), addressId);
    }

    const getAggregatedAddress = (address: ICenterAddress) => {
        let results: string[] = [];

        results.push(address.typeName + ': ');
        results.push(address.addressLine1 + ', ');

        if (address.addressLine2 != '') {
            results.push(address.addressLine2 + ', ');
        }

        if (address.addressLine3 != '') {
            results.push(address.addressLine3 + ', ');
        }

        results.push(address.city + ', ');
        results.push(address.stateAbbreviation + ' ');
        results.push(address.postalCode);

        return results.join('');
    }

    return (
        <>
            <Modal show={props.show} backdrop='static' onHide={props.onCancel}>
                <Modal.Header>
                    <Modal.Title>Order Brochures for Campaign</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <FormWrapper>
                        <FormGroup>
                            <Col xs={12} sm={5} componentClass={ControlLabel}>Campaign</Col>
                            <Col xs={12} sm={6}>
                                <span>{props.campaignName}</span>
                            </Col>
                        </FormGroup>

                        <FormGroup>
                            <Col xs={12} sm={5} componentClass={ControlLabel}>How many brochures?</Col>
                            <Col xs={12} sm={6}>
                                <MaskedInput
                                    className='form-control'
                                    mask='1111'
                                    placeholder='####'
                                    // style={{ borderColor: this.state.validation.startDate ? '#ccc' : '#a94442' }}
                                    value={orderCount}
                                    onChange={handleOrderCountChange}
                                />
                            </Col>
                        </FormGroup>

                        <FormGroup>
                            <Col xs={12} sm={5} componentClass={ControlLabel}>Shipping address for order?</Col>
                            <Col xs={12} sm={6}>
                                <FormControl
                                    componentClass='select'
                                    value={addressId}
                                    onChange={handleShippingAddressChange}
                                >
                                    <option value={0}>- Select a Center Address -</option>
                                    {props.addressList.map((address, index) =>
                                        <option key={'addr-' + index} value={address.id}>{getAggregatedAddress(address)}</option>
                                    )}
                                </FormControl>
                            </Col>
                        </FormGroup>
                    </FormWrapper>
                </Modal.Body>

                <Modal.Footer>
                    <Button bsStyle='primary' disabled={orderCount == '' || addressId == 0} onClick={handleSubmit}>Submit Order</Button>
                    <Button onClick={props.onCancel}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default OrderBrochures;